// localStorage can throw (Safari private browsing, disabled storage, quota
// exceeded) — all localStorage access goes through these wrappers, which
// fail to a safe default (null / no-op) instead of propagating.
export function safeStorageGet(key: string): string | null {
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

export function safeStorageSet(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value)
  } catch {}
}

export function safeStorageRemove(key: string): void {
  try {
    window.localStorage.removeItem(key)
  } catch {}
}

// sessionStorage equivalents — same failure modes, same no-throw contract.
// Use these where state should survive navigation within a tab but must not
// outlive it (a per-session override that must never become a one-way door).
export function safeSessionGet(key: string): string | null {
  try {
    return window.sessionStorage.getItem(key)
  } catch {
    return null
  }
}

export function safeSessionSet(key: string, value: string): void {
  try {
    window.sessionStorage.setItem(key, value)
  } catch {}
}

export function safeSessionRemove(key: string): void {
  try {
    window.sessionStorage.removeItem(key)
  } catch {}
}
